module.exports = __webpack_public_path__ + "static/media/Sam_A@3x.6e383176.jpg";